import styled from 'styled-components';
import { ButtonContainer } from './ButtonContainer';

export const ContactsStageButtonContainer = styled(ButtonContainer)`
  margin: 15px 0 0 0;
`;
